import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 매장대회리스트
const get_admintournamentlist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: 1,
    pagesize: 0,
    tournamentlistcnt: 0,
    tournamentlist: [],
  };

  const options = {
    method: "GET",
    url: "/tournament/tournamentlist",
    params: {
      status: param.status,
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
      display_flag: param.display_flag,
      tour_rank_type: param.tour_rank_type,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_admintournamentlist", err);
    result(false, err);
  }
};

// 통합관리대회랭킹리스트
const get_admintournamentranklist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentranklistcnt: 0,
    tournamentranklist: [],
    tournamentname: "",
  };

  const options = {
    method: "GET",
    url: "/tournament/tournamentranklist/" + param.tournamentno,
    params: {
      scoretype: param.scoretype,
      gender: param.gender,
      pageno: param.pageno,
      pagesize: param.pagesize,      
      tour_rank_type: param.tour_rank_type,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_admintournamentranklist", err);
    result(false, err);
  }
};

// 통합관리대회보기
const get_admintournamentview = async (tournamentno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentshopname: 0,
    tournamentinfo: [],
    tournamentprizeetc: [],
    tournamentprizerankcnt: 0,
    tournamentprizerank: [],
    tournamentdetail: [],
    tournamentcoursecnt: 0,
    tournamentcourse: [],
    tournamentshoplistcnt: 0,
    tournamentshoplist: [],
  };

  const options = {
    method: "GET",
    url: "/tournament/tournamentinfo/" + tournamentno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_admintournamentview", err);
    result(false, err);
  }
};

// 통합관리대회코스리스트
const get_admintournamentcourselist = async (tournamentno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    courselistcnt: 0,
    courselist: [],
  };

  const options = {
    method: "GET",
    url: "/tournament/tournamentcourselist/" + tournamentno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_admintournamentcourselist", err);
    result(false, err);
  }
};

// 통합관리대회서브코스리스트
const get_admintournamentsubcourselist = async (courseno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    subcourselistcnt: 0,
    subcourselist: [],
  };

  const options = {
    method: "GET",
    url: "/tournament/tournamentsubcourselist/" + courseno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_admintournamentsubcourselist", err);
    result(false, err);
  }
};

// 챔피언십 등록
const set_admintournamentwrite = async (form, result) => {
  console.log(form);
  form.rankprizelist.rankprize.splice(form.rankno);

  form.subcourseno = form.subcourselist.map((v) => v.subcourseno);

  form.rankno = form.rankno;
  form.rankprize = form.rankprizelist.rankprize;
  console.log("form", form);
  const data = new FormData();

  for (let key in form) {
    if (Array.isArray(form[key])) {
      form[key].forEach((v) => data.append(key + "[]", v));
    } else {
      data.append(key, form[key]);
    }
  }
  const options = {
    method: "POST",
    url: "/tournament/tournamentwrite",
    data: data,
  };
  try {
    await axios(options).then((response) => {
      // result(true, response.data)
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        // console.error(response.data.code, response.data.message)
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_admintournamentwrite", err);
    result(false, err);
  }
};

// 챔피언십 수정
const set_ownertournamentedit = async (form, tournamentno, result) => {
  form.rankprizelist.rankprize.splice(form.rankno);

  form.subcourseno = form.subcourselist.map((v) => v.subcourseno);

  form.rankno = form.rankno;
  form.rankprize = form.rankprizelist.rankprize;
  console.log("form", form);
  const data = new FormData();

  for (let key in form) {
    if (Array.isArray(form[key])) {
      form[key].forEach((v) => data.append(key + "[]", v));
    } else {
      data.append(key, form[key]);
    }
  }

  const options = {
    method: "POST",
    url: "/tournament/tournamentwrite/" + tournamentno,
    data: data,
  };

  try {
    await axios(options).then((response) => {
      // result(true, response.data)
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_ownertournamentwrite", err);
    result(false, err);
  }
};

// 통합관리대회매장리스트
const get_admintournamentshoplist = async (tournamentno, form, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentshoplistcnt: 0,
    tournamentshoplist: [],
    shoplistcnt: 0,
    shoplist: [],
  };

  const options = {
    method: "GET",
    url: "/tournament/tournamentshoplist/" + tournamentno,
    params: {
      searchtype: form.searchtype,
      searchname: form.searchname,
      pageno: form.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_admintournamentcourselist", err);
    result(false, err);
  }
};

// 통합관리대회매장리스트2(등록)
const get_admintournamentshoplist2 = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentshoplist2cnt: 0,
    tournamentshoplist2: [],
  };

  const options = {
    method: "GET",
    url: "/tournament/tournamentshoplist2",
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_admintournamentshoplist2", err);
    result(false, err);
  }
};

// 통합관리대회매장참가신청
const set_admintournamentshopapply = async (tournamentno, shopno, result) => {
  const options = {
    method: "PUT",
    url: "/postact/tournamentshopapply/" + tournamentno + "/" + shopno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data.message);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("set_admintournamentshopapply", err);
    result(false, err);
  }
};

// 통합관리대회매장참가삭제
const set_admintournamentshopdrop = async (tournamentno, shopno, result) => {
  const options = {
    method: "PUT",
    url: "/postact/tournamentshopdrop/" + tournamentno + "/" + shopno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data.message);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("set_admintournamentshopdrop", err);
    result(false, err);
  }
};

const set_admintournamentplayersave = async (
  tournamentno,
  tour_member_items,
  result
) => {
  const options = {
    method: "POST",
    url: "/postact/tournamentplayersave/" + tournamentno,
    data: qs.stringify(tour_member_items),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_admintournamentplayerapply", err);
    result(false, err);
  }
};

// 회원정보보기
const get_playerinfo = async (player, type, result) => {
  let finalData = {
    code: "",
    message: "",
    playerbasicinfo: [],
    playerpalyinfo: [],
  };

  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/common/playerinfo",
    params: {
      player: player,
      type: type,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_playerinfo", err);
    result(false, err);
  }
};

// 통합관리일반회원리스트
const get_playerlist = async (params, result) => {
  let finalData = {
    code: 200,
    message: "",
    pageno: 1,
    pagesize: 5,
    playerlistcnt: "0",
    playerlist: [],
  };
  const options = {
    method: "GET",
    url: "/membership/playerlist",
    params: {
      pagesize: 5,
      membertype: params.membertype,
      status: params.status,
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_playerlist", err);
    result(false, err);
  }
};

// 통합관리일반회원리스트
const get_tourplayerlist = async (tournamentno, params, result) => {
  let finalData = {
    code: 200,
    message: "",
    pageno: 1,
    pagesize: 5,
    playerlistcnt: "0",
    playerlist: [],
  };
  const options = {
    method: "GET",
    url: "/tournament/tourplayerlist/" + tournamentno,
    params: {
      pagesize: 5,
      membertype: params.membertype,
      status: params.status,
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_tourplayerlist", err);
    result(false, err);
  }
};

// 통합관리토너먼트삭제
const set_admintourdelete = async (tournamentno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "DELETE",
    url: "/postact/tournamentdelete/" + tournamentno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_admintourdelete", err);
    result(false, err);
  }
};

const set_reprocess = async (tour_pk, result) => {
  let finalData = {
    code: 0,
    message: "",
  };

  const options = {
    method: "GET",
    url: "/tournament/reprocess/" + tour_pk,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

// 토너먼트 조건 불러오기
const get_tournamentcondition = async (tournamentno, result) => {
  let finalData = {
    code: "",
    message: "",
    tournamentcondition: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/tournamentcondition/" + tournamentno,
    headers: { Authorization: "Bearer " + token },
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  };
  try {
    await axios(options).then((response) => {
      console.log(response);
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_tournamentcondition", err);
  }
};

// 토너먼트참가리스트
const get_admintournamentplaylist = async (tour_pk, player_pk, result) => {
  let finalData = {
    code: "",
    message: "",
    pageno: 1,
    pagesize: 10,
    tournamentname: "",
    tournamentplaylistcnt: 0,
    tournamentplaylist: [],
  };
  const token = sessionStorage.getItem("token") || null;
  console.log("player_pk", player_pk);
  const options = {
    method: "GET",
    url:
      process.env.VUE_APP_API_URL +
      "/tournament/tournamentplaylist/" +
      tour_pk +
      "/" +
      player_pk,
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_membertournamentplaylist", err);
    result(false, err);
  }
};

const get_memberscorecard = async (player_pk, define1_pk, result) => {
  let finalData = {
    code: "",
    message: "",
    scorecardinfo: {},
    scorecardstats: {},
    scorecardscore: {},
    scorecardtotal: {},
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url:
      process.env.VUE_APP_API_URL +
      "/tournament/scorecard/" +
      player_pk +
      "/" +
      define1_pk,
    //url: 'http://localhost/test.php',
    headers: { Authorization: "Bearer " + token },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_memberscorecard", err);
    result(false, err);
  }
};

// 토너먼트 결제 리스트
const get_tournamentpaymentlist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentpaymentlistcnt: 0,
    tournamentpaymentlist: [],
  };

  const options = {
    method: "GET",
    url: "/tournament/tournamentpaymentlist/" + param.tour_pk,
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_tournamentpaymentlist", err);
    result(false, err);
  }
};

// 토너먼트 결제 리스트
const get_playerpaymentlist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    listcnt: 0,
    list: [],
  };

  const options = {
    method: "GET",
    url:
      "/membership/playerpaymentlist/" +
      param.player_pk +
      "/" +
      param.tour_pk +
      "/" +
      param.owner_pk,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_playerpaymentlist", err);
    result(false, err);
  }
};

const post_paymentrefund = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "POST",
    url: "/postact/paymentrefund/" + params.tod_pk,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},

    // params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const excelSave = async (tournamentno, params, result) => {
  let finalData = {
    code: 0,
    message: "",
  };
  const options = {
    method: "GET",
    url: "/tournament/tourplayerlist/" + tournamentno + "/excel",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //data: qs.stringify({})
    params: {
      pagesize: 5,
      membertype: params.membertype,
      status: params.status,
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
    },
  };

  await axios(options).then((response) => {
    // alert(response.headers["content-disposition"]);
    // console.log(response);
    //  let header = response.headers["Content-Disposition"];

    // let filenameTmp = header.split("=");
    // let filename = filenameTmp[1];
    // let filename = "member_". date("Y-m-d") .".xls";

    result(response.data);
  });
};

export default {
  get_admintournamentlist,
  get_admintournamentranklist,
  get_admintournamentview,
  get_admintournamentcourselist,
  get_admintournamentsubcourselist,
  set_admintournamentwrite,
  set_ownertournamentedit,
  get_admintournamentshoplist,
  get_admintournamentshoplist2,
  set_admintournamentshopapply,
  set_admintournamentshopdrop,
  set_admintournamentplayersave,
  get_playerinfo,
  get_playerlist,
  get_tourplayerlist,
  set_admintourdelete,
  set_reprocess,
  get_tournamentcondition,
  get_admintournamentplaylist,
  get_memberscorecard,
  get_tournamentpaymentlist,
  get_playerpaymentlist,
  post_paymentrefund,
  excelSave,
};
